const Unauthorized = () => (
    <div className="text-center mt-10 text-red-600 text-xl">
      You are not authorized to view this page.
    </div>
  );
  
  export default Unauthorized;
  